<template xmlns:v-card-subtitle="http://www.w3.org/1999/html">
  <div>
    <v-app-bar
      app
      class="primary darken-1 px-1 px-sm-4 px-md-5 elevation-0"
      height="110"
      role="navigation"
    >
      <v-toolbar-title>
        <div
          class="d-flex align-center"
          @click="scroll(top)"
          tag="span"
          style="cursor: pointer"
        >
          <v-img
            :src="require('@/assets/infohidronamebranco.svg')"
            contain
            alt="logo infohidro"
            :height="$vuetify.breakpoint.name === 'xs' ? '30' : '62'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100' : '212'"
          ></v-img>
        </div>
<!--        <div class="content" @click="scroll(top)" tag="span" style="cursor: pointer">
          <h2>INFOHIDRO</h2>
          <h2>INFOHIDRO</h2>
        </div>-->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn
          style="text-transform: none"
          text
          v-for="item in menuItems"
          :key="item.title"
          @click="scroll(item.link)"
        >
          <span style="font-size: 1rem">{{ item.title }}</span>
        </v-btn>
      </v-toolbar-items>
      <v-btn
        class="ml-12"
        style="text-transform: none"
        outlined
        large
        color="secondary lighten-1"
        to="/Login"
      >
        <span style="font-size: 1rem">Login</span>
      </v-btn>
    </v-app-bar>
    <v-main role="main" style="overflow-x: hidden">
      <section id="WaterResourcesManagement" aria-label="Gestão de recursos hídricos" class="mb-16 mt-6">
        <v-container>
          <v-row
            v-if="
              $vuetify.breakpoint.name === 'xs' ||
              $vuetify.breakpoint.name === 'sm'
            "
            align="center"
            justify="center"
          >
            <v-col cols="12">
              <v-card-title>
                <h6
                  class="water-resources-management-title-mobile"
                  style="line-height: 7px"
                >
                  Gestão de Recursos Hídricos
                </h6>
              </v-card-title>
              <v-card-title>
                <h1 class="water-resources-management-subtitle-mobile">
                  A plataforma<br />
                  que transformou<br />
                  dados em<br />
                  informação.
                </h1>
              </v-card-title>
              <v-card-text>
                <span class="water-resources-management-text-mobile">
                  Informações baseadas em<br />
                  dados especializaos para o<br />
                  auxílio à
                  <strong class="water-resources-management-text-mobile--strong"
                    >tomada de decisão</strong
                  >
                  e<br />
                  <strong class="water-resources-management-text-mobile--strong"
                    >uso sustentável dos recursos</strong
                  ><br />
                  <strong class="water-resources-management-text-mobile--strong"
                    >hídricos</strong
                  >
                </span>
              </v-card-text>
              <v-card-actions class="ml-2">
                <div class="water-resources-management-buttons-mobile">
                  <v-btn
                    style="
                      text-transform: none;
                      padding: 16px 24px;
                      height: 52px;
                    "
                    color="secondary lighten-1"
                    @click="scroll(form)"
                  >
                    <span style="font-size: 1rem">Solicitar acesso</span>
                  </v-btn>

                  <v-btn
                    style="
                      text-transform: none;
                      padding: 16px 24px;
                      height: 52px;
                    "
                    text
                    color="secondary lighten-1"
                    @click="scroll(about)"
                  >
                    <span style="font-size: 1rem">Sobre o infohidro</span>
                  </v-btn>
                </div>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-col>
          </v-row>
          <v-row v-else align="center" justify="center">
            <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12 : 6">
              <v-card-title>
                <h6
                  class="water-resources-management-title"
                  style="line-height: 7px"
                >
                  Gestão de Recursos Hídricos
                </h6>
              </v-card-title>
              <v-card-title>
                <h1 class="water-resources-management-subtitle">
                  A plataforma<br />
                  que transformou<br />
                  dados em informação.
                </h1>
              </v-card-title>
              <v-card-text>
                <span class="water-resources-management-text">
                  Informações baseadas em dados especializados<br />
                  para o auxílio à
                  <strong class="water-resources-management-text--strong"
                    >tomada de decisão</strong
                  >
                  e
                  <strong class="water-resources-management-text--strong"
                    >uso</strong
                  ><br />
                  <strong class="water-resources-management-text--strong"
                    >sustentável dos recursos hídricos</strong
                  >.
                </span>
              </v-card-text>
              <v-card-actions class="ml-2">
                <div class="water-resources-management-buttons">
                  <v-btn
                    color="secondary lighten-1"
                    style="
                      text-transform: none;
                      padding: 16px 24px;
                      height: 52px;
                    "
                    @click="scroll(form)"
                  >
                    <span style="font-size: 1rem">Solicitar acesso</span>
                  </v-btn>

                  <v-btn
                    text
                    color="secondary lighten-1"
                    style="
                      text-transform: none;
                      padding: 16px 24px;
                      height: 52px;
                    "
                    @click="scroll(about)"
                  >
                    <span style="font-size: 1rem">Sobre o infohidro</span>
                  </v-btn>
                </div>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6">
              <div class="mt-6">
                <v-img
                  :src="require('@/assets/imagem-destaque.png')"
                  alt="Imagem Destaque"
                />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="Forecast" aria-label="Previsão do tempo" class="mb-16 mt-16" style="background: rgb(149,161,236); background: linear-gradient(180deg, rgba(149,161,236,0.2) 0%, rgba(255,255,255,0) 100%);">
        <v-container>
          <v-row align="center" justify="center">
            <weather-forecast></weather-forecast>
          </v-row>
        </v-container>
      </section>

      <section id="About" aria-label="Sobre o infohidro" class="mb-16 mt-16">
        <about></about>
      </section>

      <section id="Map" aria-label="Mapa do Tempo">
        <time-map />
      </section>

      <section id="Form" aria-label="Fomulário de solicitação de acesso ao infohidro" class="mb-16 mt-16">
        <v-row no-gutters align="center" justify="center">
          <v-img max-height="875" :src="require('@/assets/bg_icones.png')" alt="">
            <v-container fill-height>
              <v-row align="center" class="white--text" justify="center">
                <v-col cols="12" sm="12" md="12" lg="12" xl="8">
                  <solicitation-form role="form"></solicitation-form>
                </v-col>
              </v-row>
            </v-container>
          </v-img>
        </v-row>
      </section>

      <section id="Simepar" aria-label="Sobre o Simepar" class="mb-16 mt-16">
        <simepar-mobile v-if="$vuetify.breakpoint.name === 'xs'" />
        <simepar-tablet v-else-if="$vuetify.breakpoint.name === 'sm'" />
        <simepar v-else />
      </section>
    </v-main>
    <div>
      <footer-weather role="contentinfo"></footer-weather>
    </div>
  </div>
</template>

<script>
import * as easings from "vuetify/lib/services/goto/easing-patterns";
import About from "../../components/weather/About";
import Simepar from "../../components/weather/Simepar";
import SimeparMobile from "../../components/weather/SimeparMobile";
import SimeparTablet from "../../components/weather/SimeparTablet";
import TimeMap from "../../components/weather/TimeMap.vue";
import SolicitationForm from "../../components/weather/SolicitationForm";
import FooterWeather from "../../components/weather/FooterWeather";
import WeatherForecast from "../../components/weather/WeatherForecast";

export default {
  name: "Weather",
  components: {
    WeatherForecast,
    FooterWeather,
    SolicitationForm,
    About,
    Simepar,
    SimeparMobile,
    SimeparTablet,
    TimeMap,
  },
  data() {
    return {
      top: "#WaterResourcesManagement",
      about: "#About",
      form: "#Form",
      //-------------------------------------------Scroll------------------------------------------------
      type: "number",
      number: 9999,
      selector: "#first",
      selected: "Button",
      elements: ["Button", "Radio group"],
      duration: 1000,
      offset: 15,
      easing: "easeInQuint",
      easings: Object.keys(easings),
      offsetTop: 0,
      //---------------------------------------------------------------------------------------------------
      menuItems: [
        { title: "Sobre", link: "#About" },
        { title: "Mapa do tempo", link: "#Map" },
        { title: "Simepar", link: "#Simepar" },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      const recaptcha = this.$recaptchaInstance;
      recaptcha.showBadge();
    }, 3000);
  },
  beforeDestroy() {
    const recaptcha = this.$recaptchaInstance;
    recaptcha.hideBadge();
  },
  computed: {
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
  },
  methods: {
    scroll(val) {
      this.$vuetify.goTo(val, this.options);
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Poppins";
  src: local("Poppins"),
    url("../../assets/fonts/Poppins/Poppins-SemiBold.ttf") format("truetype");
}

@font-face {
  font-family: "Questrial";
  src: local("Questrial"),
    url("../../assets/fonts/Questrial/Questrial-Regular.ttf") format("truetype");
}

.water-resources-management-title {
  /*position: absolute;*/
  /*width: 257px;*/
  height: 24px;
  left: 0px;
  top: -1px;

  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;

  display: flex;
  align-items: center;
  text-transform: uppercase;

  color: #ffffff;
}

.water-resources-management-title-mobile {
  /*position: absolute;*/
  width: 200px;
  height: 22px;
  left: 0px;
  top: 0px;

  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  /* UI Fonte Branca */

  color: #ffffff;
}

.water-resources-management-subtitle {
  /* position: absolute;*/
  width: 562px;
  height: 204px;

  left: 0px;
  top: 30px;

  font-family: "Questrial", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 2.812rem;
  line-height: 68px;

  display: flex;
  align-items: center;

  color: #ffffff;
}

.water-resources-management-subtitle-mobile {
  /*position: absolute;*/
  width: 322px;
  height: 200px;
  left: 0px;
  top: 38px;

  font-family: "Questrial";
  font-style: normal;
  font-weight: 350;
  font-size: 2.5rem;
  line-height: 39px;
  display: flex;
  align-items: center;

  /* UI Fonte Branca */

  color: #ffffff;
}

.water-resources-management-text {
  /*position: absolute;*/
  width: 472px;
  height: 81px;
  left: 0px;
  top: 258px;

  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 1.125rem;
  line-height: 27px;
}

.water-resources-management-text--strong {
  color: #95a1ec;
}

.water-resources-management-text-mobile {
  /*position: absolute;*/
  width: 312px;
  height: 150px;
  left: 0px;
  top: 218px;

  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 30px;
}

.water-resources-management-text-mobile--strong {
  color: #ffffff;
}

.water-resources-management-buttons {
  line-height: 77px;
}

.water-resources-management-buttons-mobile {
  line-height: 25px;
  display: flex;
}
.content {
  position: fixed;
}
.content h2 {
  color: #fff;
  position: absolute; letter-spacing: 3px;
  margin-left: 150px;
  transform: translate(-50%, -50%); font-weight: 800 !important;
  font-size: 50px;
}
.content h2:nth-child(1) {
  color: transparent; -webkit-text-stroke: 1px #fff;
}
.content h2:nth-child(2) {
  background: linear-gradient(
    90deg,
    rgba(96, 113, 219, 1) 0%,
    rgba(149, 161, 236, 1) 25%,
    rgba(149, 161, 236, 1) 50%,
    rgba(149, 161, 236, 1) 75%,
    rgba(96, 113, 219, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: animate 4s ease-in-out infinite;
}
@keyframes animate {
  0%,
  100% {
    clip-path: polygon(0% 45%, 15% 44%, 32% 50%, 54% 60%, 70% 61%, 84% 59%, 100% 52%, 100% 100%, 0% 100%);
  }
  50% {
    clip-path: polygon(0% 60%, 16% 65%, 34% 66%, 51% 62%, 67% 50%, 84% 45%, 100% 46%, 100% 100%, 0% 100%);
  }
}
</style>
